import styled from "styled-components";

const StyledCard = styled.div`
  &.card-statistic-primary-container {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 12px 29px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 20px 20px 16px;
    width: 100%;

    h4 {
      color: #1e1919;
      font-size: 22px;
      font-weight: 700;
      line-height: 24px;
      margin: unset;
    }

    h5 {
      color: #1e1919;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      margin: unset;
    }

    p {
      color: #505050;
      font-size: 12px;
      line-height: 24px;
      margin: unset;
    }
  }
`;

export default StyledCard;
